import styled from 'styled-components';
import { Palette } from 'core/config';
import { FiX } from 'react-icons/fi';

export const Money = styled.div`
  border-radius: 1.5rem;
  max-width: 35rem;
  height: 45rem;
  position: relative;
  overflow: hidden;

  .fade-in {
    opacity: 1;
  }

  @media only screen and (min-width: 375px) and (max-width: 450px) {
    max-width: 23rem;
    height: 33rem;
  }
`;

export const MoneyPopup = styled.img`
  height: 100%;
`;

export const HiddenButton = styled.button`
  position: absolute;
  padding: 1.2rem 3.6rem;
  bottom: 3rem;
  left: 6.2rem;
  opacity: 0;
  cursor: pointer;

  @media only screen and (min-width: 375px) and (max-width: 450px) {
    font-size: 12px;
    padding: 0.76rem 1.75rem;
    bottom: 2.2rem;
    left: 4.55rem;
  }
`;

export const MoneyContent = styled.div`
  opacity: 0;
  transition: opacity 0.5s linear 0s;
  height: 100%;
  width: 100%;
`;

export const CloseButton = styled(FiX)`
  position: absolute;
  top: 2rem;
  right: 2rem;
  width: 2rem;
  height: 2rem;
  color: ${Palette.BLACK};

  &:hover {
    cursor: pointer;
  }

  @media only screen and (min-width: 375px) and (max-width: 450px) {
    top: 1rem;
    right: 1rem;
  }
`;
